<div>
    <h1 style="color:#e7bd42">La nostra mission</h1>
    <p style="line-height: 1.6">Performance Training non è PALESTRA e non è STUDIO P.T. ma LAB!</p>
</div>

<div class="layout horizontal center middle" style="margin: 0;color: white; flex-wrap: wrap;">
    <div class="layout orizontal center middle" style="border: 2px solid #e7bd42; border-radius: 15px 50px; background-color: #212121; margin: 10px; width: 500px;">
            <p style="margin:20px; line-height: 1.6; color:white">Possibilità di allenarsi su appuntamento col proprio trainer ma anche possibilità di accesso autonomo, con
                prenotazione, per evitare affollamenti e riuscire a garantire la tranquillità a chi si sta allenando col
                trainer.</p>
    </div>

    <div class="layout orizontal center middle" style="border: 2px solid #e7bd42; border-radius: 15px 50px; background-color: #212121; margin: 10px; width: 500px;">
            <p style="margin:20px; line-height: 1.6; color:white">Performance Training Lab nasce con l’obbiettivo di soddisfare le esigenze dei clienti che vogliono allenarsi in una location esclusiva e riservata con professionisti e con sistemi di monitoraggio di allenamento di ultima generazione.</p>
    </div>
</div>


<!-- <div class="layout orizontal center middle">
    <img style="width:60%" src="assets/images/gym1.jpg" />
    <div class="layout horizontal center middle" style="width: 40%; background-color: #212121">
        <p style="margin:20px;font-size: 18px; line-height: 1.6">Possibilità di allenarsi su appuntamento col proprio trainer ma anche possibilità di accesso autonomo, con
            prenotazione, per evitare affollamenti e riuscire a garantire la tranquillità e a chi si sta allenando col
            trainer.</p>
    </div>
</div>

<div class="layout orizontal center middle" style="margin-top:20px">
    <div class="layout horizontal center middle" style="width: 40%; background-color: #212121">
        <p style="margin:20px;font-size: 18px; line-height: 1.6">Performance Training Lab nasce con l’obbiettivo di soddisfare le esigenze dei clienti che vogliono allenarsi,
            in una location esclusiva e confortevole, lontano dal caos e dallo stress quotidiano e nel contempo offrire
            un ambiente ENJOY.</p>
    </div>
    <img style="width:60%" src="assets/images/gym2.jpg" />
</div> -->